module.exports = __webpack_public_path__ + "static/pinkpanther-tracenosmooth-4137d53fc4dd110f87e0672b183bf4c9.png";